module.exports = __webpack_public_path__ + "img/Harmony.67f5640d.png";